var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraPlugin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10.667,
    viewBox: "0 0 16 10.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4968",
    "data-name": "Path 4968",
    d: "M0,65.778A1.779,1.779,0,0,1,1.778,64H8.889a1.779,1.779,0,0,1,1.778,1.778v7.111a1.779,1.779,0,0,1-1.778,1.778H1.778A1.779,1.779,0,0,1,0,72.889Zm15.531-.783a.89.89,0,0,1,.469.783v7.111a.889.889,0,0,1-1.383.739L11.95,71.85l-.394-.264V67.081l.394-.264,2.667-1.778a.892.892,0,0,1,.914-.044Z",
    transform: "translate(0 -64)",
    fill: "#fcfcfc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPlugin);
export default __webpack_public_path__ + "static/media/camera-plugin.8c6da7d8f4f5e82083e90e5250b11b0d.svg";
export { ForwardRef as ReactComponent };